<script setup lang="ts">
import type { VSwitchRowGroupProps } from "./VSwitchRow.types";
import { provide } from "vue";
import VListCard from "../ListCard/VListCard.vue";
import { switchRowGroupListClass } from "./switchRow.cva";
import { SWITCH_ROW_LIST_KEY, SWITCH_ROW_TALL_KEY } from "./VSwitchRow.types";

defineOptions({
  name: "VSwitchRowGroup",
});

const { variant = "list", tall = false } = defineProps<VSwitchRowGroupProps>();

defineSlots<{
  default?: () => unknown
}>();

provide(SWITCH_ROW_LIST_KEY, variant === "list");
provide(SWITCH_ROW_TALL_KEY, variant === "list" && tall);
</script>

<template>
  <VListCard v-if="variant === 'list'" :class="switchRowGroupListClass">
    <slot />
  </VListCard>
  <div
    v-else
    class="ml-3 flex flex-col gap-[18px] border-l-2 border-gray-300 py-1 pl-5 dark:border-dark-600"
  >
    <slot />
  </div>
</template>
